import React, { ReactNode } from 'react';
import styles from './assets/payroll-screen.module.scss';
import classNames from 'classnames';
import PayrollsGrid from './components/PayrollsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreatePayrollButton from './components/CreatePayrollButton';
import RoleLayout from 'src/components/layout/RoleLayout';
import { IPayroll } from 'src/types/payroll';
import { RouteComponentProps, withRouter } from 'react-router';
import Loader from '../../../../../../components/Loader';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';

export interface StateProps {
    data: Paginated<IPayroll>;
    inProgress: boolean;
    providers: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    getProviders: (params: QueryParams) => void;
    getDataInFile: (params: QueryParams) => void;
}

export interface OwnProps extends RouteComponentProps {
    history: any;
}
export interface Props extends StateProps, DispatchProps, OwnProps {}

class PayrollsList extends React.Component<Props> {
    componentDidMount() {
        this.props.getProviders({});
    }
    getDataAct = (params: QueryParams) => {
        const { getData, history } = this.props;
        const periodsHistory: any = history?.location?.state?.periodStart
            ? {
                  'periodStart[after]': history?.location?.state?.periodStart,
                  'periodStart[before]': history?.location?.state?.periodStart,
                  'periodEnd[before]': history?.location?.state?.periodEnd,
                  'periodEnd[after]': history?.location?.state?.periodEnd,
              }
            : {};

        getData({ ...params, filters: { ...params.filters, ...periodsHistory } });
    };
    render(): ReactNode {
        const { data, providers, inProgress } = this.props;

        const isProvider = user.getRoles().includes(UserRole.ROLE_USER);
        const isSupervisor = user.getSupervisor();
        return (
            <RoleLayout>
                {isProvider && !isSupervisor ? null : <div className={'isGetCsv'}></div>}
                <div className={classNames(`pageHeading`, styles.heading)}>
                    <h2 className={classNames(`pageHeadingTitle`, styles.title)}>
                        PAYROLLS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                    <CreatePayrollButton />
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <PayrollsGrid
                        providers={providers}
                        getDataCsv={this.props.getDataCsv}
                        getDataInFile={this.props.getDataInFile}
                        data={data}
                        getData={this.getDataAct}
                    />
                </div>
            </RoleLayout>
        );
    }
}

export default withRouter(PayrollsList);
